/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Orders.css";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import DataTableTemplatingDemo from "../../components/orders/DataTableTemplatingDemo/DataTableTemplatingDemo";
import ModalAdd from "../../components/orders/model/ModelAdd";
import { serverTimestamp } from "firebase/firestore";
import { Tabs, Popover } from "antd";
import { useTranslation } from "react-i18next";
import {
  Plus,
  Search,
  ListOrdered,
  AlertCircle,
  Clock,
  CheckCircle2,
  Truck,
  PackageCheck,
  XCircle,
  Loader2,
  RefreshCw,
} from "lucide-react";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../../firebase";
import { Timestamp } from "firebase/firestore";
import { useLocation } from "react-router-dom";
import { fetchOrders as fetchOrdersAction } from "../../redux/orders/orders";

function Orders() {
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const search = queryParams.get("search");
  const today = queryParams.get("today");
  const products = useSelector((state) => state.ProductsReducer);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setFilter(search);
  }, [search]);

  useEffect(() => {
    if (today == 1) {
      handleTabChange("1");
    } else if (today == 3) {
      handleTabChange("1");
      setFilter2("3");
    } else if (today == 6) {
      handleTabChange("1");
      setFilter2("6");
    }
  }, [today]);

  // Calculer le timestamp pour aujourd'hui à minuit
  const todayy = new Date();
  todayy.setHours(0, 0, 0, 0);
  const todayTimestamp = Timestamp.fromDate(todayy);

  // Calculate the timestamp for a week ago
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7); // Subtract 7 days
  const oneWeekAgoTimestamp = Timestamp.fromDate(oneWeekAgo);

  // Calculate the timestamp for a month ago (approximately 30 days)
  const oneMonthAgo = new Date();
  oneMonthAgo.setDate(oneMonthAgo.getDate() - 30);
  const oneMonthAgoTimestamp = Timestamp.fromDate(oneMonthAgo);

  const [selectedFilterDate, setSelectedFilterDate] = useState("week");

  const [endDate, setEndDate] = useState("");
  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    setSelectedFilterDate("cstome");
    const targetDate = new Date(endDate);
    const currentDate = new Date();
    const timeDifference = targetDate.getTime() - currentDate.getTime();
    const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    const d = new Date();
    d.setDate(d.getDate() + parseInt(daysDifference));
    const dTimestamp = Timestamp.fromDate(d);
    setFilterFirebase(dTimestamp);
    setSelectedFilterDate("custom");
  };

  const [data, setData] = useState([]);
  const [isLoadingOrders, setIsLoadingOrders] = useState(true);
  const [isRefreshingOrders, setIsRefreshingOrders] = useState(false);
  const onSave = (order) => {
    setData((prevData) => {
      if (!order?.id) {
        return prevData;
      }

      const exists = prevData.some((item) => item.id === order.id);

      if (exists) {
        return prevData.map((item) =>
          item.id === order.id ? { ...item, ...order } : item,
        );
      }

      return [order, ...prevData];
    });
  };

  const onStatusChange = (orderId, updatedOrder) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === orderId ? { ...item, ...updatedOrder } : item,
      ),
    );
  };
  const [filterFirebase, setFilterFirebase] = useState(oneWeekAgoTimestamp);
  const account = useSelector((state) => state.AccountReducer);
  const [lgShow, setLgShow] = useState(false);
  const [showSideBar, setShowSideBar] = useState(true);
  const auth = getAuth();
  const isRTL = i18n.language === "ar";
  const [confirmers, setConfirmers] = useState([]);
  const [selectedConfirmer, setSelectedConfirmer] = useState("all");

  const refreshOrdersFromFirebase = async ({ showLoader = false } = {}) => {
    if (!account) {
      setData([]);
      setIsLoadingOrders(false);
      setIsRefreshingOrders(false);
      return;
    }

    if (showLoader) {
      setIsLoadingOrders(true);
    } else {
      setIsRefreshingOrders(true);
    }

    try {
      const fetchUpperBound = Timestamp.fromDate(new Date());
      const snapshot = await getDocs(
        query(
          collection(db, "orders"),
          where("user", "==", account?.user),
          where("timeStamp", "<", fetchUpperBound),
          where("timeStamp", ">", filterFirebase),
        ),
      );

      const list = snapshot.docs
        .filter((doc) => {
          const data = doc.data();
          return data.type !== "digitalProducts" && !("type" in data);
        })
        .map((doc) => ({ id: doc.id, ...doc.data() }));

      const visibleOrders = list.filter((order) => order.deleted !== 1);

      setData(
        visibleOrders
          .sort((a, b) => b.timeStamp.seconds - a.timeStamp.seconds)
          .map((item, index) => ({
            ...item,
            index: visibleOrders.length - index + 999,
          })),
      );
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingOrders(false);
      setIsRefreshingOrders(false);
    }
  };

  useEffect(() => {
    refreshOrdersFromFirebase({ showLoader: true });
  }, [filterFirebase, account?.user]);

  const handleRefreshOrders = () => {
    refreshOrdersFromFirebase();
  };

  useEffect(() => {
    if (!account?.user) return;

    const fetchConfirmers = async () => {
      try {
        const confirmersQuery = query(
          collection(db, "workers"),
          where("ownerId", "==", account.user),
          where("role", "==", "confirmer"),
          where("deleted", "!=", true),
        );
        const snapshot = await getDocs(confirmersQuery);
        const list = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setConfirmers(list);
      } catch (error) {
        console.error("Error fetching confirmers:", error);
      }
    };

    fetchConfirmers();
  }, [account?.user]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [pageSize, setPageSize] = useState(() => {
    const saved = localStorage.getItem("ordersPageSize");
    return saved ? parseInt(saved) : 10;
  });
  const [orders, setOrders] = useState([]);
  const [dataForm, setDataForm] = useState({
    user: account?.user,
    productId: "",
    name: "",
    phone: "",
    state: "",
    paid: "0",
    address: "",
    commune: "",
    deleveryStatus: "1",
    stopdeskDelivery: false,
    deleveryPrice: 0,
    products: [],
    deliveryPrice: 0,
    qty: "",
    total: 0,
    options: "",
    paymentType: t("orders.cash_on_delivery"),
    timeStamp: serverTimestamp(),
  });

  useEffect(() => {
    setOrders(data);
  }, [data]);

  useEffect(() => {
    dispatch(fetchOrdersAction(data));
  }, [data, dispatch]);

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState([]);

  const [isPageSizeOpen, setIsPageSizeOpen] = useState(false);

  const pageSizeOptions = [
    { value: 5, label: t("orders.five_orders") },
    { value: 10, label: t("orders.ten_orders") },
    { value: 25, label: t("orders.twenty_five_orders") },
    { value: 50, label: t("orders.fifty_orders") },
    { value: 100, label: t("orders.onehandred_orders") },
  ];

  const handlePageSizeSelect = (value) => {
    setPageSize(value);
    localStorage.setItem("ordersPageSize", value);
    setIsPageSizeOpen(false);
  };
  const onDelete = (orderId) => {
    setData((prevData) => prevData.filter((item) => item.id !== orderId));
  };
  const toggleProduct = (name) => {
    setSelected((prev) =>
      prev.includes(name)
        ? prev.filter((pname) => pname !== name)
        : [...prev, name],
    );
  };
  const [filter, setFilter] = useState("");
  const [filter2, setFilter2] = useState("");

  const handleAdd = () => {
    setDataForm({
      user: account?.user,
      productId: "",
      name: "",
      phone: "",
      phone2: "",
      state: "",
      paid: "0",
      address: "",
      isValid: false,
      nameproduct: ".",
      commune: "",
      deleveryStatus: "1",
      stopdeskDelivery: false,
      products: [],
      deliveryPrice: 0,
      qty: 1,
      total: 0,
      note: "",
      options: "",
      paymentType: t("orders.cash_on_delivery"),
      timeStamp: serverTimestamp(),
    });
    setLgShow(true);
  };

  const { TabPane } = Tabs;

  const handleTabChange = (activeKey) => {
    switch (activeKey) {
      case "1":
        setFilterFirebase(todayTimestamp);
        setSelectedFilterDate("day");
        break;
      case "2":
        setFilterFirebase(oneWeekAgoTimestamp);
        setSelectedFilterDate("week");
        break;
      case "3":
        setFilterFirebase(oneMonthAgoTimestamp);
        setSelectedFilterDate("month");
        break;
      default:
        break;
    }
  };

  const getUniqueDaysCount = (statusTimeline) => {
    if (!Array.isArray(statusTimeline)) return 0;

    const uniqueDates = new Set();

    statusTimeline.forEach((item) => {
      if (item.timestamp) {
        let timestamp = item.timestamp;

        // Validate timestamp and ensure it's a valid date
        if (timestamp.seconds) {
          timestamp = new Date(timestamp.seconds * 1000);
        } else if (isNaN(new Date(timestamp))) {
          return; // Skip invalid timestamp
        } else {
          timestamp = new Date(timestamp); // fallback
        }

        const dayString = timestamp.toISOString().split("T")[0]; // YYYY-MM-DD
        uniqueDates.add(dayString);
      }
    });

    return uniqueDates.size;
  };

  const filteredOrders =
    selected.length > 0
      ? orders.filter((order) =>
          order.products.some((product) => selected.includes(product.name)),
        )
      : orders;

  const filteredOrdersByConfirmer = confirmers.length
    ? filteredOrders.filter((order) => {
        if (selectedConfirmer === "all") return true;
        if (selectedConfirmer === "unassigned") {
          return !order?.assignedConfirmerId;
        }
        return order?.assignedConfirmerId === selectedConfirmer;
      })
    : filteredOrders;

  const content = (
    <div>
      <form onSubmit={handleSearchSubmit} className="d-flex">
        <div
          className={`border p-2 ms-2 ${
            selectedFilterDate !== "month" &&
            selectedFilterDate !== "week" &&
            selectedFilterDate !== "day"
              ? "bg-info"
              : ""
          }`}
        >
          <input
            type="date"
            id="endDateInput"
            name="endDateInput"
            value={endDate}
            onChange={handleEndDateChange}
            required
          />
        </div>

        <button type="submit">
          {" "}
          <img
            src="https://cdn-icons-png.flaticon.com/128/1168/1168610.png"
            type="submit"
            className="icon w-10 h-10 "
          />
        </button>
      </form>
    </div>
  );

  return (
    <div
      className="container-fluid bg-purple-50 dark:!bg-[#181919]  min-h-screen"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 bg-[#fbf8fc] dark:!bg-[#141414]"
          style={{ flex: 1 }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm p-4 m-3 mt-6 border border-purple-100 dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                  {t("orders.Order_Management")}
                </h2>
                <p className="text-gray-600 dark:text-gray-300 mb-0">
                  {t("orders.Order_Mentoring")}
                </p>
              </div>
            </div>
          </div>

          {/* Date Filter Tabs */}
          <div className="mx-3 mb-3 flex items-center justify-between">
            <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm border border-purple-100 dark:!border-[#3c3a3d] overflow-hidden">
              <div className="flex">
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${
                    selectedFilterDate === "day"
                      ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                      : "text-gray-600 hover:bg-purple-50 dark:text-gray-300 "
                  }`}
                  onClick={() => handleTabChange("1")}
                >
                  {t("orders.day")}
                </button>
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${
                    selectedFilterDate === "week"
                      ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                      : "text-gray-600 hover:bg-purple-50 dark:text-gray-300 "
                  }`}
                  onClick={() => handleTabChange("2")}
                >
                  7 {t("orders.days")}
                </button>
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${
                    selectedFilterDate === "month"
                      ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                      : "text-gray-600 hover:bg-purple-50 dark:text-gray-300"
                  }`}
                  onClick={() => handleTabChange("3")}
                >
                  {t("orders.month")}
                </button>
                <Popover placement="bottom" content={content} trigger="click">
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/4799/4799625.png"
                    alt={t("ui.calendarIcon")}
                    className="w-8 h-8 cursor-pointer mx-2 mt-[8px]"
                  />
                </Popover>
              </div>
            </div>
          </div>

          {/* Status Filter Cards */}
          <div className="mx-3 mb-4 overflow-x-auto py-2 px-1">
            <div className="flex md:grid md:grid-cols-4 lg:grid-cols-10 gap-3 min-w-max md:min-w-0">
              <button
                onClick={() => setFilter2("")}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${
                  filter2 === ""
                    ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                    : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${
                    filter2 === ""
                      ? "bg-[#efd3ff] dark:bg-[#181919]"
                      : "bg-[#faf1ff] dark:bg-[#181919]"
                  } flex items-center justify-center mr-3`}
                >
                  <ListOrdered
                    size={18}
                    className={`${
                      filter2 === "" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  />
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${
                      filter2 === ""
                        ? "text-[#9e68ba] "
                        : "text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {t("orders.all")}
                  </div>
                  <div
                    className={`font-bold ${
                      filter2 === "" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  >
                    {
                      orders.filter(
                        (order) =>
                          order.deleveryStatus !== "8" &&
                          order.deleveryStatus !== "20",
                      ).length
                    }
                  </div>
                </div>
              </button>

              <button
                onClick={() => setFilter2("1")}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${
                  filter2 === "1"
                    ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                    : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${
                    filter2 === "1"
                      ? "bg-[#efd3ff] dark:bg-[#181919]"
                      : "bg-[#faf1ff] dark:bg-[#181919]"
                  } flex items-center justify-center mr-3`}
                >
                  <AlertCircle
                    size={18}
                    className={`${
                      filter2 === "1" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  />
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${
                      filter2 === "1"
                        ? "text-[#9e68ba]"
                        : "text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {t("orders.new")}
                  </div>
                  <div
                    className={`font-bold ${
                      filter2 === "1"
                        ? "text-[#9e65bb]"
                        : "text-[#9e68ba] dark:!text-gray-300"
                    }`}
                  >
                    {
                      orders.filter((order) => order.deleveryStatus === "1")
                        .length
                    }
                  </div>
                </div>
              </button>

              <button
                onClick={() => setFilter2("11")}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${
                  filter2 === "11"
                    ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                    : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${
                    filter2 === "11"
                      ? "bg-[#efd3ff] dark:bg-[#181919]"
                      : "bg-[#faf1ff] dark:bg-[#181919]"
                  } flex items-center justify-center mr-3`}
                >
                  <Clock
                    size={18}
                    className={`${
                      filter2 === "11" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  />
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${
                      filter2 === "11"
                        ? "text-[#9e68ba]"
                        : "text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {t("orders.pending_confirmation")}
                  </div>
                  <div
                    className={`font-bold ${
                      filter2 === "11" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  >
                    {
                      orders.filter((order) => {
                        const uniqueDays = getUniqueDaysCount(
                          order.statusTimeline,
                        );
                        return (
                          (order.deleveryStatus === "11-1" ||
                            order.deleveryStatus === "11-2" ||
                            order.deleveryStatus === "11-3" ||
                            order.deleveryStatus === "11-4" ||
                            order.deleveryStatus === "11-5") &&
                          uniqueDays < 3
                        );
                      }).length
                    }
                  </div>
                </div>
              </button>

              <button
                onClick={() => setFilter2("3")}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${
                  filter2 === "3"
                    ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                    : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${
                    filter2 === "3"
                      ? "bg-[#efd3ff] dark:bg-[#181919]"
                      : "bg-[#faf1ff] dark:bg-[#181919]"
                  } flex items-center justify-center mr-3`}
                >
                  <CheckCircle2
                    size={18}
                    className={`${
                      filter2 === "3" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  />
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${
                      filter2 === "3"
                        ? "text-[#9e68ba]"
                        : "text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {t("orders.confirmed")}
                  </div>
                  <div
                    className={`font-bold ${
                      filter2 === "3" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  >
                    {
                      orders.filter((order) => order.deleveryStatus === "3")
                        .length
                    }
                  </div>
                </div>
              </button>

              <button
                onClick={() => setFilter2("4")}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${
                  filter2 === "4"
                    ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                    : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${
                    filter2 === "4"
                      ? "bg-[#efd3ff] dark:bg-[#181919]"
                      : "bg-[#faf1ff] dark:bg-[#181919]"
                  } flex items-center justify-center mr-3`}
                >
                  <Truck
                    size={18}
                    className={`${
                      filter2 === "4" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  />
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${
                      filter2 === "4"
                        ? "text-[#9e68ba]"
                        : "text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {t("orders.at_delivery_company")}
                  </div>
                  <div
                    className={`font-bold ${
                      filter2 === "4" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  >
                    {
                      orders.filter((order) => order.deleveryStatus === "4")
                        .length
                    }
                  </div>
                </div>
              </button>

              <button
                onClick={() => setFilter2("5")}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${
                  filter2 === "5"
                    ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                    : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${
                    filter2 === "5"
                      ? "bg-[#efd3ff] dark:bg-[#181919]"
                      : "bg-[#faf1ff] dark:bg-[#181919]"
                  } flex items-center justify-center mr-3`}
                >
                  <PackageCheck
                    size={18}
                    className={`${
                      filter2 === "5" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  />
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${
                      filter2 === "5"
                        ? "text-[#9e68ba]"
                        : "text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {t("orders.completed")}
                  </div>
                  <div
                    className={`font-bold ${
                      filter2 === "5" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  >
                    {
                      orders.filter((order) => order.deleveryStatus === "5")
                        .length
                    }
                  </div>
                </div>
              </button>
              <button
                onClick={() => setFilter2("imaginary")}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${
                  filter2 === "imaginary"
                    ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                    : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${
                    filter2 === "imaginary"
                      ? "bg-[#efd3ff] dark:bg-[#181919]"
                      : "bg-[#faf1ff] dark:bg-[#181919]"
                  } flex items-center justify-center mr-3`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="none"
                    stroke={filter2 === "imaginary" ? "#9e65bb" : "#9e68ba"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-alert-triangle"
                  >
                    <path d="M10.29 3.86 1.82 18a1 1 0 0 0 .86 1.5h18.64a1 1 0 0 0 .86-1.5L13.71 3.86a1 1 0 0 0-1.72 0z" />
                    <line x1="12" y1="9" x2="12" y2="13" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                  </svg>
                </div>

                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${
                      filter2 === "imaginary"
                        ? "text-[#9e68ba]"
                        : "text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {t("orders.isImaginary")}
                  </div>

                  <div
                    className={`font-bold ${
                      filter2 === "imaginary"
                        ? "text-[#9e65bb]"
                        : "text-[#9e68ba]"
                    }`}
                  >
                    {
                      orders.filter((order) => order.isImaginary === true)
                        .length
                    }
                  </div>
                </div>
              </button>

              <button
                onClick={() => setFilter2("6")}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${
                  filter2 === "6"
                    ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                    : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${
                    filter2 === "6"
                      ? "bg-[#efd3ff] dark:bg-[#181919]"
                      : "bg-[#faf1ff] dark:bg-[#181919]"
                  } flex items-center justify-center mr-3`}
                >
                  <XCircle
                    size={18}
                    className={`${
                      filter2 === "6" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  />
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${
                      filter2 === "6"
                        ? "text-[#9e68ba]"
                        : "text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {t("orders.cancelled")}
                  </div>
                  <div
                    className={`font-bold ${
                      filter2 === "6" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  >
                    {
                      orders.filter((order) => {
                        const uniqueDays = getUniqueDaysCount(
                          order.statusTimeline,
                        );
                        return (
                          order.deleveryStatus === "6" ||
                          order.deleveryStatus === "6-1" ||
                          order.deleveryStatus === "6-2" ||
                          order.deleveryStatus === "6-3" ||
                          order.deleveryStatus === "6-4" ||
                          (order.deleveryStatus === "11-1" &&
                            uniqueDays >= 3) ||
                          (order.deleveryStatus === "11-2" &&
                            uniqueDays >= 3) ||
                          (order.deleveryStatus === "11-3" &&
                            uniqueDays >= 3) ||
                          (order.deleveryStatus === "11-4" &&
                            uniqueDays >= 3) ||
                          (order.deleveryStatus === "11-5" && uniqueDays >= 3)
                        );
                      }).length
                    }
                  </div>
                </div>
              </button>

              <button
                onClick={() => setFilter2("6-4")}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${
                  filter2 === "6-4"
                    ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                    : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${
                    filter2 === "6-4"
                      ? "bg-[#efd3ff] dark:bg-[#181919]"
                      : "bg-[#faf1ff] dark:bg-[#181919]"
                  } flex items-center justify-center mr-3`}
                >
                  <XCircle
                    size={18}
                    className={`${
                      filter2 === "6-4" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  />
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${
                      filter2 === "6-4"
                        ? "text-[#9e68ba]"
                        : "text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {t("orders.datatable_templating_demo.cancelled_auto")}
                  </div>
                  <div
                    className={`font-bold ${
                      filter2 === "6-4" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  >
                    {
                      orders.filter((order) => order.deleveryStatus === "6-4")
                        .length
                    }
                  </div>
                </div>
              </button>

              <button
                onClick={() => setFilter2("8")}
                className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${
                  filter2 === "8"
                    ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                    : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                }`}
              >
                <div
                  className={`w-8 h-8 rounded-lg ${
                    filter2 === "8"
                      ? "bg-[#efd3ff] dark:bg-[#181919]"
                      : "bg-[#faf1ff] dark:bg-[#181919]"
                  } flex items-center justify-center mr-3`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke={filter2 === "8" ? "#9e65bb" : "#9e68ba"}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-trash2-icon lucide-trash-2"
                  >
                    <path d="M3 6h18" />
                    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                    <line x1="10" x2="10" y1="11" y2="17" />
                    <line x1="14" x2="14" y1="11" y2="17" />
                  </svg>
                </div>
                <div className={`${isRTL ? "text-right" : "text-left"} mx-2`}>
                  <div
                    className={`text-sm font-medium ${
                      filter2 === "8"
                        ? "text-[#9e68ba]"
                        : "text-gray-800 dark:!text-gray-300"
                    }`}
                  >
                    {t("orders.deleted")}
                  </div>
                  <div
                    className={`font-bold ${
                      filter2 === "8" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                    }`}
                  >
                    {
                      orders.filter((order) => order.deleveryStatus === "8")
                        .length
                    }
                  </div>
                </div>
              </button>
            </div>
          </div>

          {/* Search and Filter Bar */}
          <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm p-4 mx-3 mb-4 border border-purple-100 dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div className="relative flex-grow max-w-xl">
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <Search size={16} className="text-gray-400" />
                </div>
                <input
                  type="text"
                  className="bg-gray-50 border border-gray-200 dark:!border-[#3c3a3d] text-gray-900 dark:bg-[#181919] text-sm rounded-lg block w-full pr-10 p-2.5 focus:outline-none focus:ring-2 focus:ring-purple-200"
                  placeholder={t("orders.search_placeholder")}
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                />
              </div>

              <div className="flex flex-wrap items-center justify-between gap-3">
                <div className="flex items-center gap-4 w-full sm:w-auto">
                  {/*  ayoub dahabeya   <div className="relative">
                    <div className="group relative bg-gray-50 dark:bg-[#181919] border border-gray-200 dark:!border-[#3c3a3d] hover:border-[#9b59bf] text-gray-900 text-sm rounded-lg p-2.5 min-w-[220px] transition-all duration-200 hover:shadow-sm">
                      <div className="flex items-center gap-2">
                        <svg
                          className="w-4 h-4 text-[#9b59bf]"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" />
                        </svg>
                        <select
                          className="w-full bg-transparent outline-none text-gray-900 dark:text-gray-300 font-medium"
                          value={selectedConfirmer}
                          onChange={(e) => setSelectedConfirmer(e.target.value)}
                        >
                          <option value="all">
                            {t("adduser.all_confirmers")}
                          </option>
                          <option value="unassigned">
                            {t("orders.datatable_templating_demo.unassigned")}
                          </option>
                          {confirmers.map((confirmer) => (
                            <option key={confirmer.id} value={confirmer.id}>
                              {confirmer.name ||
                                confirmer.fullName ||
                                confirmer.username ||
                                confirmer.email ||
                                confirmer.id}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div> */}
                  <div className="relative">
                    {/* Main Trigger Button */}
                    <div
                      onClick={() => setIsOpen(!isOpen)}
                      className="group relative bg-gray-50 dark:bg-[#181919] border border-gray-200 dark:!border-[#3c3a3d] hover:border-[#9b59bf] text-gray-900 text-sm rounded-lg p-2.5 cursor-pointer min-w-[180px] transition-all duration-200 hover:shadow-sm focus:ring-2 focus:ring-purple-200"
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          {/* Product Icon */}
                          <div className="w-5 h-5 bg-[#faf1ff]  dark:bg-[#181919] rounded-md flex items-center justify-center">
                            <svg
                              className="w-3 h-3 text-[#9b59bf]"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V4z" />
                            </svg>
                          </div>

                          {/* Text Content */}
                          <span className="font-medium text-gray-900 dark:text-gray-300">
                            {selected.length > 0
                              ? selected.length === 1
                                ? t("orders.one_product")
                                : t("orders.multiple_products", {
                                    count: selected.length,
                                  })
                              : t("orders.select_products")}
                          </span>
                        </div>

                        {/* Arrow Icon with Animation */}
                        <div
                          className={`transform transition-transform duration-200 ${
                            isOpen ? "rotate-180" : ""
                          }`}
                        >
                          <svg
                            className="w-4 h-4 text-gray-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </div>
                      </div>

                      {/* Selected count badge */}
                      {selected.length > 0 && (
                        <div className="absolute -top-1 -right-1 bg-[#9b59bf] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold shadow-sm">
                          {selected.length}
                        </div>
                      )}
                    </div>

                    {/* Dropdown Menu */}
                    <div className="relative">
                      {isOpen && (
                        <>
                          {/* Backdrop for mobile */}
                          <div
                            className="fixed inset-0  bg-opacity-5 z-40 md:hidden"
                            onClick={() => setIsOpen(false)}
                          />

                          {/* Dropdown Container */}
                          <div
                            className="absolute mt-1 bg-white dark:bg-[#181919] dark:text-gray-300 border border-gray-200 dark:!border-[#3c3a3d] rounded-lg shadow-lg max-h-60 overflow-hidden w-full animate-in slide-in-from-top-1 duration-150"
                            style={{
                              zIndex: 100000,
                            }}
                          >
                            {/* Header */}
                            <div className="bg-[#faf1ff] dark:bg-[#181919] px-4 py-2.5 border-b border-purple-100 dark:!border-[#3c3a3d]">
                              <div className="flex items-center justify-between">
                                <span className="font-medium text-gray-800 dark:text-gray-300 text-sm">
                                  {t("orders.available_products")}
                                </span>
                                {selected.length > 0 && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelected([]);
                                    }}
                                    className="text-xs text-[#9b59bf] hover:text-[#814a9f] font-medium transition-colors"
                                  >
                                    {t("orders.clear_all")}
                                  </button>
                                )}
                              </div>
                            </div>

                            {/* Products List */}
                            <div
                              className="max-h-48 overflow-y-auto"
                              style={{
                                scrollbarWidth: "thin",
                                scrollbarColor: "#d8b4fe #f5f5f5",
                                zIndex: 100000,
                              }}
                            >
                              {products.map((product, index) => {
                                const isSelected = selected.includes(
                                  product.name,
                                );
                                return (
                                  <label
                                    key={product.id}
                                    className={`group dark:bg-[#181919] flex items-center gap-2 px-4 py-2.5 hover:bg-[#faf1ff] cursor-pointer transition-colors duration-150 ${
                                      isSelected
                                        ? "bg-[#faf1ff] border-r-2 border-[#9b59bf]"
                                        : ""
                                    }`}
                                  >
                                    {/* Custom Checkbox */}
                                    <div className="relative flex-shrink-0">
                                      <input
                                        type="checkbox"
                                        checked={isSelected}
                                        onChange={() =>
                                          toggleProduct(product.name)
                                        }
                                        className="sr-only"
                                      />
                                      <div
                                        className={`w-4 h-4 rounded border transition-all duration-200 flex items-center justify-center ${
                                          isSelected
                                            ? "bg-[#9b59bf] dark:!bg-[#181919] border-[#9b59bf]"
                                            : "border-gray-300 hover:border-[#9b59bf]"
                                        }`}
                                      >
                                        {isSelected && (
                                          <svg
                                            className="w-3 h-3 text-white"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                              clipRule="evenodd"
                                            />
                                          </svg>
                                        )}
                                      </div>
                                    </div>

                                    {/* Product Name */}
                                    <span
                                      className={`text-sm transition-colors ${
                                        isSelected
                                          ? "text-[#9b59bf] font-medium"
                                          : "text-gray-800 dark:text-gray-300 group-hover:text-[#9b59bf]"
                                      }`}
                                    >
                                      {product.name}
                                    </span>

                                    {/* Selection Indicator */}
                                    {isSelected && (
                                      <div className="w-1.5 h-1.5 bg-[#9b59bf] rounded-full ml-auto" />
                                    )}
                                  </label>
                                );
                              })}
                            </div>

                            {/* Empty State */}
                            {products.length === 0 && (
                              <div className="px-4 py-8 text-center text-gray-500">
                                <div className="w-8 h-8 mx-auto mb-2 text-gray-300">
                                  <svg fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M10 2L3 7v11a1 1 0 001 1h12a1 1 0 001-1V7l-7-5zM10 12a2 2 0 100-4 2 2 0 000 4z" />
                                  </svg>
                                </div>
                                <span className="text-sm">
                                  {t("orders.no_products_available")}
                                </span>
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  {/* Sélecteur de page */}
                  <div className="relative">
                    {/* Main Trigger Button */}
                    <div
                      onClick={() => setIsPageSizeOpen(!isPageSizeOpen)}
                      className="group relative bg-gray-50 dark:bg-[#181919] border border-gray-200 dark:!border-[#3c3a3d] hover:border-[#9b59bf] text-gray-900 text-sm rounded-lg p-2.5 cursor-pointer min-w-[140px] transition-all duration-200 hover:shadow-sm focus:ring-2 focus:ring-purple-200"
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          {/* Page Size Icon */}
                          <div className="w-5 h-5 bg-[#faf1ff] dark:bg-[#181919] rounded-md flex items-center justify-center">
                            <svg
                              className="w-3 h-3 text-[#9b59bf]"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M3 4a1 1 0 000 2h14a1 1 0 100-2H3zM3 10a1 1 0 000 2h14a1 1 0 100-2H3zM3 16a1 1 0 100 2h14a1 1 0 100-2H3z" />
                            </svg>
                          </div>

                          {/* Current Selection */}
                          <span className="font-medium text-gray-900 dark:text-gray-300">
                            {pageSizeOptions.find(
                              (option) => option.value == pageSize,
                            )?.label || t("orders.ten_orders")}
                          </span>
                        </div>

                        {/* Arrow Icon with Animation */}
                        <div
                          className={`transform transition-transform duration-200 ${
                            isPageSizeOpen ? "rotate-180" : ""
                          }`}
                        >
                          <svg
                            className="w-4 h-4 text-gray-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>

                    {/* Dropdown Menu */}
                    <div className="relative">
                      {isPageSizeOpen && (
                        <>
                          {/* Backdrop for mobile */}
                          <div
                            className="fixed inset-0  bg-opacity-5 z-40 md:hidden"
                            onClick={() => setIsPageSizeOpen(false)}
                          />

                          {/* Dropdown Container */}
                          <div
                            className="absolute mt-1 bg-white dark:!bg-[#181919] border border-gray-200 dark:!border-[#3c3a3d] rounded-lg shadow-lg overflow-hidden w-full animate-in slide-in-from-top-1 duration-150"
                            style={{ zIndex: 100000 }}
                          >
                            {/* Header */}
                            <div className="bg-[#faf1ff] dark:bg-[#141414] px-4 py-2.5 border-b border-purple-100 dark:!border-[#3c3a3d]">
                              <span className="font-medium text-gray-800 dark:text-gray-300 text-sm">
                                {t("orders.orders_per_page")}
                              </span>
                            </div>

                            {/* Options List */}
                            <div className="max-h-48 overflow-y-auto">
                              {pageSizeOptions.map((option) => {
                                const isSelected = pageSize == option.value;
                                return (
                                  <button
                                    key={option.value}
                                    onClick={() =>
                                      handlePageSizeSelect(option.value)
                                    }
                                    className={`w-full group flex items-center gap-2 px-4 py-2.5 hover:bg-[#faf1ff] cursor-pointer transition-colors duration-150 text-right ${
                                      isSelected
                                        ? "bg-[#faf1ff] dark:!bg-[#2a2b2b] border-r-2 border-[#9b59bf]"
                                        : ""
                                    }`}
                                  >
                                    {/* Selection Indicator */}
                                    <div className="relative flex-shrink-0">
                                      <div
                                        className={`w-4 h-4 rounded-full border transition-all duration-200 flex items-center justify-center ${
                                          isSelected
                                            ? "bg-[#9b59bf] border-[#9b59bf]"
                                            : "border-gray-300 hover:border-[#9b59bf]"
                                        }`}
                                      >
                                        {isSelected && (
                                          <div className="w-2 h-2 bg-white rounded-full" />
                                        )}
                                      </div>
                                    </div>

                                    {/* Option Label */}
                                    <span
                                      className={`text-sm transition-colors ${
                                        isSelected
                                          ? "text-[#9b59bf] font-medium"
                                          : "text-gray-800 dark:text-gray-300 group-hover:text-[#9b59bf]"
                                      }`}
                                    >
                                      {option.label}
                                    </span>
                                  </button>
                                );
                              })}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <button
                  onClick={handleRefreshOrders}
                  disabled={isRefreshingOrders || !account?.user}
                  aria-label={t("ui.refreshOrders")}
                  title={t("ui.refreshOrders")}
                  className={`group relative bg-gray-50 dark:bg-[#181919] border border-gray-200 dark:!border-[#3c3a3d] rounded-lg p-2.5 transition-all duration-200 flex items-center justify-center ${
                    isRefreshingOrders || !account?.user
                      ? "opacity-50 cursor-not-allowed"
                      : "hover:border-[#9b59bf] hover:bg-purple-50 hover:shadow-sm"
                  }`}
                >
                  <RefreshCw
                    size={18}
                    className={`text-[#9b59bf] ${isRefreshingOrders ? "animate-spin" : ""}`}
                  />
                </button>

                <button
                  onClick={handleAdd}
                  className="w-full sm:w-auto bg-[#9b59bf] hover:bg-[#814a9f] transition-colors text-white py-2 px-4 rounded-lg text-sm font-medium flex items-center justify-center"
                >
                  <Plus set="curved" size={18} />
                  <span className="hp-ml-8" style={{ marginRight: "8px" }}>
                    {t("orders.add_new_order")}
                  </span>
                </button>
              </div>
            </div>
          </div>

          {/* Data Table */}
          <div className="mx-3 bg-white rounded-xl shadow-sm border border-purple-100 dark:!border-[#3c3a3d] p-0 mb-6 overflow-hidden">
            {isLoadingOrders ? (
              <div className="py-16 flex flex-col items-center justify-center gap-3">
                <Loader2 className="w-8 h-8 text-[#9e68ba] animate-spin" />
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-0"></p>
              </div>
            ) : (
              orders.length > 0 && (
                <DataTableTemplatingDemo
                  onDelete={onDelete}
                  setLgShow={setLgShow}
                  setData={setDataForm}
                  pageSize={pageSize}
                  filter={filter}
                  confirmers={confirmers}
                  selectedConfirmer={selectedConfirmer}
                  onStatusChange={onStatusChange}
                  orders={filteredOrdersByConfirmer.filter((order) => {
                    const uniqueDays = getUniqueDaysCount(order.statusTimeline);
                    if (filter2 === "") {
                      return (
                        order.deleveryStatus !== "8" &&
                        order.deleveryStatus !== "20"
                      );
                    } else if (filter2 === "11") {
                      return (
                        (order.deleveryStatus === "11-1" ||
                          order.deleveryStatus === "11-2" ||
                          order.deleveryStatus === "11-3" ||
                          order.deleveryStatus === "11-4" ||
                          order.deleveryStatus === "11-5") &&
                        uniqueDays < 3
                      );
                    } else if (filter2 === "6") {
                      return (
                        order.deleveryStatus === "6" ||
                        order.deleveryStatus === "6-1" ||
                        order.deleveryStatus === "6-2" ||
                        order.deleveryStatus === "6-3" ||
                        order.deleveryStatus === "6-4" ||
                        (order.deleveryStatus === "11-1" && uniqueDays >= 3) ||
                        (order.deleveryStatus === "11-2" && uniqueDays >= 3) ||
                        (order.deleveryStatus === "11-3" && uniqueDays >= 3) ||
                        (order.deleveryStatus === "11-4" && uniqueDays >= 3) ||
                        (order.deleveryStatus === "11-5" && uniqueDays >= 3)
                      );
                    } else if (filter2 === "imaginary") {
                      return order.isImaginary === true;
                    } else {
                      return order.deleveryStatus === filter2;
                    }
                  })}
                />
              )
            )}
          </div>

          <Footer />
        </div>
      </div>

      <ModalAdd
        lgShow={lgShow}
        setLgShow={setLgShow}
        dataForm={dataForm}
        setDataForm={setDataForm}
        data={data}
        onSave={onSave}
      />
    </div>
  );
}

export default Orders;
